import React, { useEffect, useRef } from 'react';
import { TextControl, TextareaControl, CheckboxControl } from '../components/ui/index.jsx';

/* Map the className passed by each renderInputRow call to its correct WP AJAX action */
const CLASS_TO_ACTION = {
  'bpsfw_select_product': 'wg_product_ajax',
  'bpsfw_select_cats': 'wg_cats_ajax',
  'bpsfw_select_tags': 'wg_tags_ajax',
  'wg_select_pags': 'wg_pages_ajax',
};

export const renderInputRow = (
  label,
  key,
  type = 'text',
  options = [],
  checkboxLabel = '',
  className = '',
  Settings = {},
  updateSetting = () => {},
  description = '',
  disabled = false
) => {
  const selectRef = useRef(null);

  useEffect(() => {
    if (type !== 'select2' || !selectRef.current) return;

    const action = CLASS_TO_ACTION[className] || 'wg_product_ajax';
    const $el = jQuery(selectRef.current);

    if (!$el.hasClass('select2-hidden-accessible')) {
      $el.select2({
        ajax: {
          url: ajaxurl,
          dataType: 'json',
          delay: 250,
          data: (params) => ({
            q: params.term,
            action,
            nonce: bpsfw_ajax_postajax.nonce,
          }),
          processResults: (data) => ({
            results: data.map((item) => ({
              id: item[0],
              text: item[1],
            })),
          }),
          minimumInputLength: 2,
        },
      });

      $el.on('change', function () {
        const cleaned = ($el.select2('data') || []).map((item) => ({
          id: String(item.id),
          text: item.text,
        }));
        updateSetting(key, cleaned);
      });
    }

    const stored = Settings[key];
    if (Array.isArray(stored) && stored.length > 0) {
      $el.empty();
      stored.forEach((item) => {
        if (!item?.id) return;
        $el.append(new Option(item.text, item.id, true, true));
      });
      $el.val(stored.map((i) => i.id)).trigger('change.select2');
    }

    if (disabled) {
      $el.prop('disabled', true).trigger('change.select2');
    } else {
      $el.prop('disabled', false).trigger('change.select2');
    }
  }, [Settings[key], disabled]);

  return (
    <div className="bui-input-row">
      <div className="bui-input-row__label">
        {label}{' '}
        {disabled && (
          <span className="pqd-pro-badge">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 7l4 4 5-7 5 7 4-4-2 13H5L3 7z" />
            </svg>
            PRO
          </span>
        )}
      </div>

      <div className={`bui-input-row__field ${type === 'radioGroup' ? 'bui-input-row__field--radio' : ''}`} style={ disabled ? {maxWidth: '658px'} : {maxWidth: '460px'}}>
        <div  className={`bui-field-with-pro ${disabled ? 'bui-disabled' : ''}`}>
          {type === 'select2' ? (
            <select
              ref={selectRef}
              disabled={disabled}
              id={key}
              className={className}
              name={key}
              style={{ width: '100%' }}
              multiple
            />
          ) : type === 'radioGroup' ? (
            <>
              {options.map((opt, index) => (
                <label key={index} style={{ display: 'block', marginBottom: '6px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name={key}
                    value={opt.value}
                    checked={Settings[key] === opt.value}
                    onChange={(e) => updateSetting(key, e.target.value)}
                    style={{ marginRight: '6px' }}
                  />
                  {opt.label}
                </label>
              ))}
              {description}
            </>
            ) : type === 'checkBox' ? (
            <CheckboxControl
              label={checkboxLabel}
              disabled={disabled}
              checked={Settings[key] === 'yes'}
              onChange={(val) => updateSetting(key, val ? 'yes' : 'no')}
            />
          ) : type === 'textArea' ? (
            <TextareaControl
              value={Settings[key]}
              disabled={disabled}
              onChange={(val) => updateSetting(key, val)}
            />
          ) : (
            <TextControl
              type={type}
              disabled={disabled}
              value={Settings[key]}
              onChange={(val) => updateSetting(key, val)}
            />
          )}

          {disabled && (
            <span className="bui-pro-inline">
              This option available in{' '}
              <a
                href="https://www.plugin999.com/plugin/build-private-store-for-woocommerce/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Pro Version
              </a>
            </span>
          )}
        </div>

        {description}
      </div>
    </div>
  );
};